export enum EOrderStatus {
    AttenteReception = 1,
    Receptionne = 2,
    AnalyseEncours = 3,
    NCEnCours = 4,
    Termine = 5
}